import {each, isArray} from "lodash";

import {createRequestActionTypes} from "../../../../../shared/ts/helpers/create_request_action_types";
import {deleteRequest} from "../../../../../shared/ts/helpers/request_wrapper";
import {catch400} from "../../../../../shared/ts/helpers/errors";
import {Dispatch, ErrorAction} from "../../../../../shared/ts/interfaces/dispatch";
import {addErrorAlert, addSuccessAlert} from "../../../shared/alerts/actions";
import {nphApiLink} from "../../../project/route/nph_api_link";
import {invalidateTdaAdvertsList} from "./fetch";

export const TDA_DELETE = "tda/DELETE";
export const tdaDeleteRequest = createRequestActionTypes(TDA_DELETE);

export const tdaDelete = (uuid: number) => (dispatch: Dispatch) => {
    dispatch({type: tdaDeleteRequest.start});

    return deleteRequest(nphApiLink.natives.delete({id: uuid}))
        .then(() => {
            dispatch({type: tdaDeleteRequest.success});
            dispatch(invalidateTdaAdvertsList());
            dispatch(addSuccessAlert("Usunięto kreację"));
            return true;
        })
        .catch(catch400(responseError => {
            const appError = responseError.appError;
            if (isArray(appError.alerts) && appError.alerts.length) {
                each(responseError.appError.alerts, (message: string) => dispatch(addErrorAlert(message, TDA_DELETE)));
            }
            else {
                dispatch(addErrorAlert("Popraw błędy formularza", TDA_DELETE));
            }
            dispatch<ErrorAction>({type: tdaDeleteRequest.error, error: responseError.appError});
            return null;
        }));
};
